module.exports = "/cyber/_next/static/images/star-f210f2f439e10f66ada2c33e8bddbf6a.png";